import { useLoad } from '../Table/hooks/useLoad';
import { LoaderContainer } from './styled';
export function TableLoader() {
    const { loading, initialLoading } = useLoad();
    if (initialLoading) {
        return null;
    }
    return <LoaderContainer $loading={loading}/>;
}
